import React, { FunctionComponent } from 'react';
import { faIdCard } from '@fortawesome/free-solid-svg-icons';
import { BrassIcon, BrassIconProps } from '..';

const BrassIconEmployeePosition: FunctionComponent<BrassIconProps> = (
  props: BrassIconProps,
) => <BrassIcon {...props} icon={faIdCard} />;

export { BrassIconEmployeePosition };
